"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorExposureLevel = void 0;
exports.getTokenExpiration = getTokenExpiration;
exports.extractBearerToken = extractBearerToken;
exports.getErrorExposureLevel = getErrorExposureLevel;
const session_1 = require("./session");
function getTokenExpiration(token) {
    try {
        const parts = token.split('.');
        const payload = parts[1];
        if (!payload) {
            return null;
        }
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const decoded = atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, '='));
        const parsed = JSON.parse(decoded);
        if (typeof parsed.exp === 'number' && Number.isFinite(parsed.exp) && parsed.exp > 0) {
            return parsed.exp;
        }
        return null;
    }
    catch {
        return null;
    }
}
function extractBearerToken(authHeader) {
    if (!authHeader) {
        return null;
    }
    const parts = authHeader.split(' ');
    const scheme = parts[0];
    const token = parts[1];
    if (parts.length !== 2 || !scheme || !token) {
        return null;
    }
    if (scheme.toLowerCase() !== 'bearer') {
        return null;
    }
    return token;
}
var ErrorExposureLevel;
(function (ErrorExposureLevel) {
    ErrorExposureLevel["Public"] = "public";
    ErrorExposureLevel["Staff"] = "staff";
    ErrorExposureLevel["StaffDetailed"] = "staff-detailed";
})(ErrorExposureLevel || (exports.ErrorExposureLevel = ErrorExposureLevel = {}));
function getErrorExposureLevel(session, allowDetailedErrors) {
    if (!session || !(0, session_1.isStaff)(session)) {
        return ErrorExposureLevel.Public;
    }
    if (allowDetailedErrors === true) {
        return ErrorExposureLevel.StaffDetailed;
    }
    return ErrorExposureLevel.Staff;
}
//# sourceMappingURL=utils.js.map